import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Loading from 'layout/Loading';
import Pagination from './Pagination';
import EventEntry from './EventEntry';
import LogbookEntry from './LogbookEntry';
import fetchItems from './fetchItems';
import ErrorMessage from '../ErrorMessage';
import { Typography } from '../../../node_modules/@material-ui/core';

const styles = theme => ({
  Logbook: {
    height: '32vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    fontSize: '0.8rem',
  },
  tableBody: {
    overflow: 'auto',
    flexGrow: 1,
    backgroundColor: '#F5F5F5',
    borderTop: '1px solid #DDD',
    borderBottom: '1px solid #DDD',
  },
  timeMarker: {
    height: '5px',
    backgroundColor: theme.logbook.palette.timeMarker,
  },
  pagination: {
    flexShrink: '0',
    height: '55px',
    padding: '2px',
    textAlign: 'right',
  },
});

export class Logbook extends Component {
  constructor(props) {
    super(props);

    this.handlePageChange = this.handlePageChange.bind(this);
    this.focusedItemNode = null;

    this.state = {
      items: [],
      year: null,
      years: [],
      loading: false,
      networkError: null,
    };
  }

  async componentDidMount() {
    this.updateContent();
  }

  async componentDidUpdate(prevProps) {
    const { elephantId, focusedDate, active } = this.props;
    const {
      years, year, loading,
    } = this.state;

    const focusedYear = focusedDate ? focusedDate.year() : null;
    const yearIsValid = years.indexOf(focusedYear) !== -1;

    // Figure out if new data needs to be fetched
    let needToUpdate = false;
    let yearToUpdate = null;
    if (elephantId !== prevProps.elephantId) {
      // If elephant changed always fetch new data
      needToUpdate = true;
    } else if (
      focusedDate
      && !focusedDate.isSame(prevProps.focusedDate)
      && focusedYear !== year
    ) {
      // If focused year changed fetch data if new focuced year is valid,
      // data is not being loaded and logbook is active (expanded)
      if (yearIsValid && !loading && active) {
        needToUpdate = true;
        yearToUpdate = focusedYear;
      }
    }
    if (needToUpdate) await this.updateContent(yearToUpdate);
  }

  async updateContent(year = null) {
    const { elephantId } = this.props;
    // Fetches logbook data for the new elephant
    try {
      this.setState({ loading: true, items: [], networkError: null });
      this.setState(await fetchItems(elephantId, year));
    } catch (err) {
      this.setState({ networkError: err });
    } finally {
      this.setState({ loading: false });
    }
  }

  handlePageChange(year) {
    this.updateContent(year);
  }

  render() {
    const { focusedDate, classes } = this.props;
    const {
      items, year, years, networkError, loading,
    } = this.state;
    const { onDateFocused } = this.props;


    const drawFocusedMarker = focusedDate && focusedDate.year() === year;
    const entries = [];
    let focusHandled = false;

    items.forEach((item) => {
      let itemFocused = false;
      if (drawFocusedMarker) {
        // is date is focused, highlight item
        if (item.date.isSame(focusedDate)) {
          focusHandled = true;
          itemFocused = true;
        } else if (!focusHandled && item.date.isSameOrAfter(focusedDate)) {
          // if focus not handled yet, and next item is passed focusDate => draw marker
          focusHandled = true;
          entries.push(<div key="tm" className={classes.timeMarker} />);
        }
      }
      entries.push(
        item.type === 'logbook'
          ? <LogbookEntry onDateSelected={onDateFocused} key={`l${item.id}`} logbook={item} focused={itemFocused} />
          : <EventEntry onDateSelected={onDateFocused} key={`e${item.id}`} event={item} focused={itemFocused} />,
      );
    });
    if (drawFocusedMarker && !focusHandled) entries.push(<div key="tm" className={classes.timeMarker} />);

    return (
      <div className={classes.Logbook}>
        {networkError ? <ErrorMessage error={networkError} />
          : (years.length === 0 && !loading) ? (
            <Typography variant="title" align="center">
              {'No records available'}
            </Typography>
          )
            : (
              <React.Fragment>
                <div className={classes.tableBody}>
                  {loading ? <Loading /> : entries }
                </div>
                {loading
                  ? <div className={classes.pagination} />
                  : (
                    <Pagination
                      className={classes.pagination}
                      pages={years}
                      currentPage={year}
                      onPageChange={this.handlePageChange}
                    />
                  )
                    }
              </React.Fragment>
            )
            }
      </div>
    );
  }
}

Logbook.propTypes = {
  classes: PropTypes.shape().isRequired,
  elephantId: PropTypes.number.isRequired,
  focusedDate: PropTypes.shape(),
  onDateFocused: PropTypes.func,
  active: PropTypes.bool,
  year: PropTypes.number,
};
Logbook.defaultProps = {
  focusedDate: null,
  onDateFocused: () => {},
  active: true,
  year: null,
};
export default withStyles(styles)(Logbook);



// WEBPACK FOOTER //
// ./src/layout/logbook/Logbook.jsx